"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7002],{

/***/ 46709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ PAGINATED_OUTPUT_NODES_FRAGMENT; },
/* harmony export */   "q": function() { return /* binding */ PAGINATED_OUTPUT_METADATA_FRAGMENT; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19989);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70463);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment PaginatedOutputNodesFragment on PaginatedOutput {\n    nodes {\n      __typename\n      id\n      color\n      masterId\n      variantProduct {\n        ...mandatoryVariantFields\n        badges {\n          id\n          label\n        }\n        percentageDiscountBadge\n        salePrice\n        productPrice {\n          price\n          salePrice\n          promotionPrice\n          isSalePriceElapsed\n          tax\n          taxRate\n        }\n        displayOutOfStock {\n          soldout\n          comingsoon\n          backsoon\n          presale\n          displayValue\n        }\n        orderable\n        promotions(page: ProductListingPage) {\n          id\n          calloutMessage\n        }\n        isAppExclusive\n        appOnlyDateTimeFrom\n        appOnlyDateTimeTo\n      }\n      masterProduct {\n        ...mandatoryMasterFields\n        brand\n        promotions(page: ProductListingPage) {\n          id\n          calloutMessage\n        }\n        amountOfReviews\n        averageRating\n        disableRatings\n        disableReviews\n        score {\n          rating\n          amount\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment PaginatedOutputMetadataFragment on PaginatedOutput {\n    sortingOptions {\n      id\n      label\n    }\n    selectedSort\n    filteringOptions {\n      id\n      label\n      values {\n        value\n        label\n        hitCount\n      }\n    }\n    totalCount\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var PAGINATED_OUTPUT_NODES_FRAGMENT = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var PAGINATED_OUTPUT_METADATA_FRAGMENT = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());


/***/ }),

/***/ 78217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ commonQueryVariables; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70169);
/* harmony import */ var utils_products__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1032);



var commonQueryVariables = function(param) {
    var router = param.router, offset = param.offset;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, (0,utils_products__WEBPACK_IMPORTED_MODULE_0__/* .createListVariables */ .tN)(router.query)), {
        offset: offset
    });
};


/***/ }),

/***/ 32629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ useScreenSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _useWindowSize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45746);


var Size;
(function(Size) {
    Size[Size["SMALL"] = 2] = "SMALL";
    Size[Size["MEDIUM"] = 3] = "MEDIUM";
    Size[Size["LARGE"] = 4] = "LARGE";
})(Size || (Size = {}));
var useScreenSize = function() {
    var width = (0,_useWindowSize__WEBPACK_IMPORTED_MODULE_1__/* .useWindowSize */ .i)().width;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), screenSize = ref[0], setScreenSize = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (width !== null) {
            var size = Size.SMALL;
            if (width < 640) size = Size.SMALL;
            else if (width < 1024) size = Size.MEDIUM;
            else size = Size.LARGE;
            setScreenSize(size);
        }
    }, [
        width
    ]);
    return screenSize;
};


/***/ }),

/***/ 37404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ Breadcrumb; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ../node_modules/string-strip-html/dist/string-strip-html.cjs.js
var string_strip_html_cjs = __webpack_require__(50967);
// EXTERNAL MODULE: ./utils/removeHyphens.ts
var removeHyphens = __webpack_require__(47802);
// EXTERNAL MODULE: ./utils/capitalize.ts
var capitalize = __webpack_require__(59308);
// EXTERNAL MODULE: ./utils/media.ts
var media = __webpack_require__(39772);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./ui/elements/InjectedScript.tsx
var InjectedScript = __webpack_require__(19735);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/urql/dist/urql.es.js
var urql_es = __webpack_require__(25380);
// EXTERNAL MODULE: ./utils/isContentOnline.ts
var isContentOnline = __webpack_require__(89996);
// EXTERNAL MODULE: ./utils/breadcrumbRedirects.ts + 1 modules
var breadcrumbRedirects = __webpack_require__(5567);
;// CONCATENATED MODULE: ./hooks/useBreadcrumbUrlRedirects.ts








var isRedirectActive = function(redirect) {
    var availableFrom = redirect.availableFrom, availableTo = redirect.availableTo;
    var isAvailable = (0,isContentOnline/* isContentOnline */.e)({
        onlineFrom: availableFrom,
        onlineTo: availableTo
    }, {});
    if (!isAvailable || !redirect.url) return false;
    return true;
};
var useBreadcrumbUrlRedirects = function(links) {
    var client = (0,urql_es/* useClient */.m8)();
    var ref = (0,react.useState)(undefined), redirections = ref[0], setRedirections = ref[1];
    var fetchRedirections = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var breadcrumbPromises, results, updatedPaths, _tmp, _tmp1, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    breadcrumbPromises = (0,breadcrumbRedirects/* fetchBreadcrumbRedirectPromises */.VD)(client, links);
                    return [
                        4,
                        Promise.all(breadcrumbPromises)
                    ];
                case 1:
                    results = _state.sent();
                    updatedPaths = results.map(function(param, idx) {
                        var data = param.data;
                        return data && isRedirectActive(data.urlRedirectV2) ? {
                            label: links[idx + 1].label,
                            url: data.urlRedirectV2.url
                        } : (0,_object_spread/* default */.Z)({}, links[idx + 1]);
                    });
                    _tmp = {};
                    _tmp1 = {};
                    if (updatedPaths.length > 0) {
                        setRedirections([
                            (0,_object_spread/* default */.Z)(_tmp, links[0])
                        ].concat((0,_to_consumable_array/* default */.Z)(updatedPaths), [
                            (0,_object_spread/* default */.Z)(_tmp1, links[links.length - 1])
                        ]));
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        client,
        links
    ]);
    return {
        fetchRedirections: fetchRedirections,
        redirections: redirections
    };
};

// EXTERNAL MODULE: ./utils/locale.ts + 1 modules
var utils_locale = __webpack_require__(79302);
;// CONCATENATED MODULE: ./ui/components/Breadcrumb.tsx
















var Breadcrumb = function(param) {
    var path = param.path, isPdpFromPlp = param.isPdpFromPlp;
    var router = (0,next_router.useRouter)();
    var ref = (0,useSiteConfig/* useSiteConfig */.N)(), host = ref.host, locale = ref.locale, absoluteLinkBreadcrumb = ref.absoluteLinkBreadcrumb, isPNARegion = ref.staticFeatures.isPNARegion;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var protocol = constants/* isServer */.sk ? "https:" : window.location.protocol;
    var baseUrlLink = "".concat(protocol, "//").concat(host).concat((0,utils_locale/* getUrlFromLocale */.bH)(locale));
    var baseUrl = absoluteLinkBreadcrumb ? baseUrlLink : "";
    var pdpUrlRegex = /^[a-z]{2}\/[a-z]{2}\/pd\/.*\/\\d{6,}/;
    var isPdp = pdpUrlRegex.test(router.pathname);
    // Build links array
    var links = (0,react.useMemo)(function() {
        return path.filter(function(pathElement) {
            return pathElement.url !== "/puma";
        }).map(function(param) {
            var label = param.label, url = param.url;
            var displayLabel = isPdp ? (0,removeHyphens/* removeHyphens */.V)(label) : label === "home" ? t("home") : label;
            var fullUrl = "".concat(baseUrl, "/").concat(encodeURI(url.length && url[0] === "/" ? url.slice(1) : url));
            return {
                label: displayLabel,
                url: fullUrl
            };
        });
    }, [
        path,
        isPdp,
        t,
        host,
        locale
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    var ref1 = useBreadcrumbUrlRedirects(links), redirections = ref1.redirections, fetchRedirections = ref1.fetchRedirections;
    (0,react.useEffect)(function() {
        if (isPNARegion && links.length > 0) {
            fetchRedirections();
        }
    }, [
        isPNARegion,
        links.length,
        fetchRedirections
    ]);
    var prevToLastLink = links[links.length - 2] || links[0];
    var showMobilePdpBreadcrumb = !(0,media/* getIsDesktop */.w)() && isPdpFromPlp;
    var removeTrailingSlash = function(url) {
        return url.endsWith("/") ? url.slice(0, -1) : url;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showMobilePdpBreadcrumb ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                className: "flex items-center font-bold",
                onClick: function() {
                    return router.back();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-0.5 mr-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                            size: "sm",
                            name: "chevron-left"
                        })
                    }),
                    prevToLastLink.label
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Breadcrumb */.aGc, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* FITANALYTICS_IS_LOADED_INDICATOR */.S7), {
                path: redirections !== null && redirections !== void 0 ? redirections : links,
                className: "-ml-1.5"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InjectedScript/* InjectedScript */.D, {
                type: "application/ld+json",
                script: JSON.stringify({
                    "@context": "https://schema.org/",
                    "@type": "BreadcrumbList",
                    itemListElement: links.map(function(item, index) {
                        return {
                            "@type": "ListItem",
                            position: index + 1,
                            name: (0,capitalize/* capitalize */.k)((0,string_strip_html_cjs.stripHtml)(item.label).result),
                            item: item.url.startsWith("http") ? item.url : removeTrailingSlash("".concat(baseUrlLink).concat(item.url)),
                            logo: "https://".concat(host, "/assets/logo-puma-black.png")
                        };
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 79892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ LoadMore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70169);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var twind_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79200);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var hooks_useIntersectionObserver__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69340);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77480);
/* harmony import */ var utils_products__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1032);
/* harmony import */ var hooks_usePageEventsContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43308);
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83168);
/* harmony import */ var hooks_useGA4ScrollEvents__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46660);












var LoadMore = function(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_5__/* .useTranslate */ .qM)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var ref1 = (0,hooks_usePageEventsContext__WEBPACK_IMPORTED_MODULE_7__/* .usePageEventsContext */ .qN)(), pageviewEventHasFired = ref1.pageviewEventHasFired, eventHasFired = ref1.eventHasFired, setEventFired = ref1.setEventFired;
    var itemListId = props.itemListId, itemListName = props.itemListName;
    var handleLoadMore = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (pageviewEventHasFired) {
            // fire scroll event 100%
            (0,hooks_useGA4ScrollEvents__WEBPACK_IMPORTED_MODULE_9__/* .firePreviousAndCurrentGA4ScrollEvents */ .k8)({
                percentage: "100",
                eventHasFired: eventHasFired,
                setEventFired: setEventFired
            });
            (0,utils_analytics__WEBPACK_IMPORTED_MODULE_8__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_8__/* .AnalyticsEvents.GA4_CustomEvent */ ._q.GA4_CustomEvent, {
                event_name: utils_analytics__WEBPACK_IMPORTED_MODULE_8__/* .AnalyticsEvents.SHOW_MORE_ALL */ ._q.SHOW_MORE_ALL,
                event_params: {
                    item_list_id: itemListId,
                    item_list_name: itemListName
                }
            });
        }
        router.replace({
            query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, router.query), {
                offset: (router.query.offset ? Number(router.query.offset) : 0) + utils_products__WEBPACK_IMPORTED_MODULE_6__/* .MAX_PRODUCT_PAGE_SIZE */ .ur
            })
        }, "", {
            scroll: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        router.query,
        eventHasFired,
        setEventFired,
        pageviewEventHasFired,
        itemListId,
        itemListName, 
    ]);
    (0,hooks_useIntersectionObserver__WEBPACK_IMPORTED_MODULE_4__/* .useIntersectionObserver */ .S)(ref, handleLoadMore, true, {
        threshold: 0.1,
        rootMargin: "700px"
    });
    var isFinalPageOfResults = (Number(router.query.offset) || 0) + utils_products__WEBPACK_IMPORTED_MODULE_6__/* .MAX_PRODUCT_PAGE_SIZE */ .ur >= props.totalCount;
    var shouldLoadMoreRefRender = props.isLastPageCurrentlyDisplayed && !isFinalPageOfResults;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: props.fetching ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            role: "region",
            "aria-live": "polite",
            "aria-atomic": true,
            className: "col-span-full",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: (0,twind_style__WEBPACK_IMPORTED_MODULE_2__.tw)("mt-8 mb-8 h-16", "bg-puma-black text-white border-1 border-puma-black", "text-base uppercase font-bold", "flex items-center justify-center", (0,twind_style__WEBPACK_IMPORTED_MODULE_2__/* .animation */ .oQ)("2s ease infinite", fadeInOut)),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        "aria-hidden": true,
                        children: t("loading")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "sr-only",
                        children: t("loadingMoreItems")
                    })
                ]
            })
        }) : shouldLoadMoreRefRender && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "invisible h-[100px]",
            ref: ref,
            "data-test-id": "product-list-load-more"
        })
    });
};
var fadeInOut = (0,twind_style__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)({
    "0%, 100%": {
        opacity: "40%"
    },
    "50%": {
        opacity: "80%"
    }
});


/***/ }),

/***/ 79072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ ProductList; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(65218);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../node_modules/twind/style/style.js
var style = __webpack_require__(79200);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(88038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
// EXTERNAL MODULE: ./ui/components/ProductListFilterProvider.tsx
var ProductListFilterProvider = __webpack_require__(64648);
// EXTERNAL MODULE: ./utils/splitThreadExecution.ts
var splitThreadExecution = __webpack_require__(75142);
// EXTERNAL MODULE: ./ui/elements/Button.tsx + 1 modules
var Button = __webpack_require__(70868);
;// CONCATENATED MODULE: ./ui/elements/ResetSearchConditionsButton.tsx






var ResetSearchConditionsButton = function() {
    var t = (0,useTranslations/* useTranslate */.qM)();
    var clearAllFilters = (0,ProductListFilterProvider/* useProductListFilterContext */.Q)().clearAllFilters;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
        variant: "black",
        height: "tall",
        className: "px-10",
        type: "button",
        onClick: function() {
            (0,splitThreadExecution/* splitThreadExecution */.K)({
                mainCallback: clearAllFilters
            })();
        },
        children: [
            t("resetSearchConditions"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "sr-only",
                children: t("resetSearchConditions")
            })
        ]
    });
};

// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
;// CONCATENATED MODULE: ./hooks/useResetConditionsButtonEnabled.ts


var useResetConditionsButtonEnabled = function() {
    var resetSearchConditionsOptions = (0,useSiteConfig/* useSiteConfig */.N)().resetSearchConditionsOptions;
    var enabledFilters = (0,ProductListFilterProvider/* useProductListFilterContext */.Q)().enabledFilters;
    return !!(enabledFilters.length > 0 && (resetSearchConditionsOptions === null || resetSearchConditionsOptions === void 0 ? void 0 : resetSearchConditionsOptions.showResetSearchConditionsButton));
};

;// CONCATENATED MODULE: ./ui/components/ProductList.tsx










var ProductListFilterComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1877).then(__webpack_require__.bind(__webpack_require__, 51877)).then(function(mod) {
        return mod.ProductListFilter;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51877)
            ];
        }
    }
});
var ProductListFilterCollapsibleComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8213).then(__webpack_require__.bind(__webpack_require__, 28213)).then(function(mod) {
        return mod.ProductListFilterCollapsible;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28213)
            ];
        }
    },
    ssr: false
});
var ProductList = function(props) {
    var ref = (0,react.useState)(false), isCompactMode = ref[0], setCompactMode = ref[1];
    var filterCollapsableEnabled = (0,useFeature/* useFeature */.S)("PRODUCT_FILTER_COLLAPSIBLE");
    var t = (0,useTranslations/* useTranslate */.qM)();
    var label = !props.search ? t("products", {
        resultCount: props.totalCount
    }) : t("productResults", {
        resultCount: props.totalCount,
        searchTerm: props.search
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: props.search && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "robots",
                    content: "noindex, follow"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "w-full flex flex-col justify-center font-display mx-auto max-w-screen-3xl",
                children: [
                    !filterCollapsableEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListFilterComponent, {
                        enabledFilterOptions: props.filteringOptions,
                        sortOptions: props.sortingOptions,
                        defaultSortOption: props.defaultSortOption
                    }),
                    filterCollapsableEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListFilterCollapsibleComponent, {
                        enabledFilterOptions: props.filteringOptions,
                        sortOptions: props.sortingOptions,
                        defaultSortOption: props.defaultSortOption
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                        "aria-label": t("layout"),
                        className: "flex w-full items-center justify-between py-5 lg:py-10 space-x-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    "data-test-id": "product-list-total-count",
                                    className: "uppercase font-bold text-lg md:text-xl",
                                    "aria-live": "assertive",
                                    "aria-atomic": true,
                                    children: !props.isFetching && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        "data-test-id": "product-results",
                                        children: label
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        "aria-pressed": isCompactMode,
                                        className: "outline-none bg-transparent p-0 border-0",
                                        onClick: function() {
                                            setCompactMode(true);
                                            if (props.handleCompactMode) props.handleCompactMode(true);
                                        },
                                        "aria-label": t("compact"),
                                        type: "button",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (0,style.tw)("m-2", isCompactMode && "border-1 border-puma-black"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "block sm:hidden",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                                                        name: "grid-col-1",
                                                        size: "2xl"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "hidden sm:block",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                                                        name: "grid-col-2",
                                                        size: "2xl"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        "aria-pressed": !isCompactMode,
                                        className: "outline-none bg-transparent p-0 border-0",
                                        onClick: function() {
                                            setCompactMode(false);
                                            if (props.handleCompactMode) props.handleCompactMode(false);
                                        },
                                        "aria-label": t("relaxed"),
                                        type: "button",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (0,style.tw)("m-2", !isCompactMode && "border-1 border-puma-black"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "block sm:hidden",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                                                        name: "grid-col-2",
                                                        size: "2xl"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "hidden sm:block lg:hidden",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                                                        name: "grid-col-3",
                                                        size: "2xl"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "hidden lg:block",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                                                        name: "grid-col-4",
                                                        size: "2xl"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        "aria-label": label,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                id: "product-list-results-title",
                                className: "sr-only",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: label
                                })
                            }),
                            !props.isFetching && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListResults, {
                                isCompactMode: isCompactMode,
                                results: props.noResults ? null : props.children
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var ProductListResults = function(param) {
    var isCompactMode = param.isCompactMode, results = param.results;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var isResetConditionsButtonEnabled = useResetConditionsButtonEnabled();
    return !results ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,style.tw)("flex justify-center flex-col items-center", isResetConditionsButtonEnabled ? "py-28" : "py-48"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                id: "no-products-found",
                className: (0,style.tw)("text-3xl font-bold text-center", isResetConditionsButtonEnabled && "mb-10"),
                children: t("noProductsFound")
            }),
            isResetConditionsButtonEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResetSearchConditionsButton, {})
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: (0,style.tw)("grid gap-x-4 gap-y-8 transition-opacity duration-700", "grid-cols-".concat(isCompactMode ? "1" : "2"), "sm:grid-cols-".concat(isCompactMode ? "2" : "3"), "lg:grid-cols-".concat(isCompactMode ? "2" : "4")),
        id: "product-list-items",
        "data-test-id": "product-list-items",
        children: results
    });
};


/***/ }),

/***/ 18815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "pk": function() { return /* binding */ ButtonClearFilter; },
  "tL": function() { return /* binding */ ProductListFilterDropdown; },
  "RW": function() { return /* binding */ focusOnFirst; },
  "i2": function() { return /* binding */ getFilterComponent; },
  "XE": function() { return /* binding */ triggerGA4CustomEvent; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(17599);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(19989);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/twind/style/style.js
var style = __webpack_require__(79200);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ./hooks/a11y/index.ts + 4 modules
var a11y = __webpack_require__(71129);
// EXTERNAL MODULE: ./hooks/a11y/focus.ts
var a11y_focus = __webpack_require__(78842);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
;// CONCATENATED MODULE: ./utils/mapColourFilterLabel.ts
/**
 * Map color filter label values to match all regions
 */ var mapLabel = function(label) {
    switch(label){
        case "multi-colored":
            return "Multi-Colored";
        case "Assorted Colours":
            return "Colored";
        case "Beige":
            return "Tan";
        default:
            return label;
    }
};

// EXTERNAL MODULE: ./utils/products.ts
var products = __webpack_require__(1032);
// EXTERNAL MODULE: ./ui/components/ProductListFilterProvider.tsx
var ProductListFilterProvider = __webpack_require__(64648);
// EXTERNAL MODULE: ./utils/analytics/index.ts + 6 modules
var analytics = __webpack_require__(83168);
// EXTERNAL MODULE: ./utils/splitThreadExecution.ts
var splitThreadExecution = __webpack_require__(75142);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./ui/components/CloseButton.tsx
var CloseButton = __webpack_require__(6485);
// EXTERNAL MODULE: ./utils/priceFilter.ts + 1 modules
var priceFilter = __webpack_require__(27523);
// EXTERNAL MODULE: ./utils/extractNumbersFromString.ts
var extractNumbersFromString = __webpack_require__(54321);
// EXTERNAL MODULE: ../node_modules/@radix-ui/react-slider/dist/index.mjs + 2 modules
var dist = __webpack_require__(82779);
// EXTERNAL MODULE: ./utils/debounce.ts
var debounce = __webpack_require__(40572);
;// CONCATENATED MODULE: ./UDS/elements/action-cta/Slider.tsx



var THUMB_SIZES = {
    xs: "h-2 w-2",
    sm: "h-4 w-4",
    base: "h-6 w-6",
    lg: "h-8 w-8",
    xl: "h-10 w-10"
};
var Slider = function(props) {
    var ref, ref1, ref2, ref3;
    var thumbStyles = "\n  block ".concat(THUMB_SIZES[(props === null || props === void 0 ? void 0 : props.thumbSize) || "base"], " border-0 border-white bg-puma-black ring-offset-neutral-30 transition-colors\n  focus:outline-none focus:ring-1 focus:ring-neutral-70 focus:ring-offset-1 focus:border-1\n  ").concat(props.disabled && "pointer-events-none bg-neutral-70", " !rounded-full");
    var debounceCallback = function(onValueCommit, debounceMs) {
        return (0,debounce/* debounce */.D)(onValueCommit, debounceMs);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Root */.fC, {
            style: {
                touchAction: "none"
            },
            className: "relative flex w-full select-none items-center",
            defaultValue: [
                (ref = props.defaultValue) === null || ref === void 0 ? void 0 : ref.min,
                (ref1 = props.defaultValue) === null || ref1 === void 0 ? void 0 : ref1.max
            ],
            step: props.step || 1,
            minStepsBetweenThumbs: 1,
            onValueChange: props.onValueChange,
            onValueCommit: function() {
                props.onValueCommit && debounceCallback(props.onValueCommit, props.debounceMs || 0);
            },
            disabled: props.disabled,
            value: [
                props.value.min,
                props.value.max
            ],
            min: (ref2 = props.defaultValue) === null || ref2 === void 0 ? void 0 : ref2.min,
            max: (ref3 = props.defaultValue) === null || ref3 === void 0 ? void 0 : ref3.max,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Track */.fQ, {
                    className: "relative h-1 w-full grow overflow-hidden rounded-full bg-gray-200",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Range */.e6, {
                        className: "absolute h-full bg-puma-black ".concat(props.disabled && "bg-neutral-70")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Thumb */.bU, {
                    className: thumbStyles
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Thumb */.bU, {
                    className: thumbStyles
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./ui/components/PriceFilterSlider.tsx













var PriceFilterSlider = function(props) {
    var ref, ref1;
    var ref2 = (0,ProductListFilterProvider/* useProductListFilterContext */.Q)(), enabledFilterOptions = ref2.enabledFilterOptions, clearFilters = ref2.clearFilters, priceRange = ref2.priceRange, setPriceRange = ref2.setPriceRange, defaultPriceRange = ref2.defaultPriceRange, isFetching = ref2.isFetching, queryParamsPriceRange = ref2.queryParamsPriceRange, totalCount = ref2.totalCount, handlePriceSliderSubmit = ref2.handlePriceSliderSubmit;
    var ref3 = (0,useSiteConfig/* useSiteConfig */.N)(), currency = ref3.currency, priceSliderInterval = ref3.priceSliderInterval, priceInputMaxLength = ref3.priceInputMaxLength;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var ref4 = (0,react.useState)(false), isTyping = ref4[0], setIsTyping = ref4[1];
    var selectedValue = ((ref1 = (ref = enabledFilterOptions["price"]) === null || ref === void 0 ? void 0 : ref.values[0]) === null || ref1 === void 0 ? void 0 : ref1.value) || undefined;
    var minInputRef = (0,react.useRef)(null);
    var maxInputRef = (0,react.useRef)(null);
    var handleInputDebounceRef = (0,react.useRef)(null);
    var // kept this enun here to a best readability
    inputKeys;
    (function(inputKeys) {
        inputKeys["max"] = "max";
        inputKeys["min"] = "min";
    })(inputKeys || (inputKeys = {}));
    var minDefaultPriceRange = Number(defaultPriceRange.min || 0);
    var maxDefaultPriceRange = Number(defaultPriceRange.max || 0);
    var handleInputChange = function(e) {
        var rawValue = e.target.value;
        var value = (0,extractNumbersFromString/* extractNumbersFromString */.a)(rawValue); // This extracts numbers only
        var inputKey = e.target.name;
        // Range validation with numeric comparison
        var isOutOfTheDefaultRange = value < minDefaultPriceRange || value > maxDefaultPriceRange;
        var isInputError = inputKey === inputKeys.min && value >= Number(priceRange.max || 0) || inputKey === inputKeys.max && value <= Number(priceRange.min || 0) || isOutOfTheDefaultRange;
        if (!isNaN(value) && value >= 0) {
            setPriceRange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, priceRange), (0,_define_property/* default */.Z)({}, inputKey, String(value))));
            // if there's a wrong value, set the default input value to be submitted
            if (isInputError) {
                (0,priceFilter/* setPriceInputError */.fU)({
                    inputName: inputKey,
                    setPriceRange: setPriceRange,
                    delay: 3000,
                    defaultPriceRange: defaultPriceRange,
                    priceRange: priceRange,
                    ref: handleInputDebounceRef
                });
            } else if (handleInputDebounceRef.current) {
                clearTimeout(handleInputDebounceRef.current);
            }
        }
    };
    // this will update the price range values when the default price rance is changed when another filter is applied (color, size) to keep the values inside of the defaultRange.
    (0,react.useEffect)(function() {
        if (isTyping) return;
        var priceMin = (0,priceFilter/* paramsOrPriceRange_Min */.rW)({
            queryParamsPriceRange: queryParamsPriceRange,
            priceRange: priceRange
        });
        var priceMax = (0,priceFilter/* paramsOrPriceRange_Max */.x$)({
            queryParamsPriceRange: queryParamsPriceRange,
            priceRange: priceRange
        });
        var paramsOrPriceMaxOutOfScope = priceMax > Number(defaultPriceRange.max || 0);
        var paramsOrPriceMinOutOfScope = priceMin < Number(defaultPriceRange.min || 0);
        if (paramsOrPriceMaxOutOfScope && paramsOrPriceMinOutOfScope) {
            // if the priceSelected.max is out of the default.max && the priceSelected.min is out of the default.min
            var newHandleSubmitValues = {
                min: defaultPriceRange.min,
                max: defaultPriceRange.max
            };
            if (queryParamsPriceRange) handlePriceSliderSubmit();
            else setPriceRange(newHandleSubmitValues);
        } else if (paramsOrPriceMaxOutOfScope) {
            var newHandleSubmitValues1 = {
                min: priceRange.min || defaultPriceRange.min,
                max: defaultPriceRange.max
            };
            if (queryParamsPriceRange) handlePriceSliderSubmit();
            else setPriceRange(newHandleSubmitValues1);
        } else if (paramsOrPriceMinOutOfScope) {
            var newHandleSubmitValues2 = {
                max: priceRange.max || defaultPriceRange.max,
                min: defaultPriceRange.min
            };
            if (queryParamsPriceRange) handlePriceSliderSubmit();
            else setPriceRange(newHandleSubmitValues2);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        priceRange,
        defaultPriceRange,
        handlePriceSliderSubmit
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col w-full ".concat(props.isFromDrawer ? "w-full pb-4" : "w-[336px] pb-2", " "),
        children: [
            isFetching && !props.isFromDrawer && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "top-0 right-0 bg-white z-40 opacity-30 absolute w-full h-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* DotAnimation */.jpF, {
                    on: true,
                    className: "absolute left-1/2 top-8 transform -translate-1/2"
                })
            }),
            selectedValue || totalCount === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonClearFilter, {
                    onClick: function() {
                        return (0,priceFilter/* handleClearFilter */.wr)(props, clearFilters);
                    }
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-3 items-center justify-center",
                "data-test-id": "".concat(props.id, "-filter-values"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-3 mb-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputText */.oHY, {
                                label: "",
                                ref: minInputRef,
                                name: inputKeys.min,
                                maxLength: priceInputMaxLength + 2,
                                value: (0,priceFilter/* addCurrencySymbol */.MG)(priceRange.min, currency.symbol),
                                onChange: function(e) {
                                    return handleInputChange(e);
                                },
                                onFocus: function() {
                                    setIsTyping(true);
                                    (0,priceFilter/* handlePriceInputFocus */.at)(minInputRef, currency.symbol);
                                },
                                onBlur: function() {
                                    return setIsTyping(false);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputText */.oHY, {
                                label: "",
                                ref: maxInputRef,
                                name: inputKeys.max,
                                maxLength: priceInputMaxLength + 2,
                                value: (0,priceFilter/* addCurrencySymbol */.MG)(priceRange.max, currency.symbol),
                                onChange: function(e) {
                                    return handleInputChange(e);
                                },
                                onFocus: function() {
                                    setIsTyping(true);
                                    (0,priceFilter/* handlePriceInputFocus */.at)(maxInputRef, currency.symbol);
                                },
                                onBlur: function() {
                                    return setIsTyping(false);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider, {
                        defaultValue: {
                            min: minDefaultPriceRange,
                            max: maxDefaultPriceRange
                        },
                        onValueChange: function(e) {
                            return setPriceRange({
                                min: String(e[0]),
                                max: String(e[1])
                            });
                        },
                        step: priceSliderInterval,
                        value: {
                            min: Number(priceRange.min || 0),
                            max: Number(priceRange.max || 0)
                        },
                        thumbSize: props.isFromDrawer ? "lg" : "base",
                        disabled: isFetching,
                        debounceMs: 1000
                    }),
                    !props.isFromDrawer && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex pt-5 justify-center mx-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                            id: "price-filter-slider-button",
                            size: "base",
                            label: t("apply"),
                            onClick: handlePriceSliderSubmit
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_PriceFilterSlider = (PriceFilterSlider);

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
;// CONCATENATED MODULE: ./ui/components/priceFilter.tsx







var PriceFilter = function(props) {
    var ref, ref1;
    var ref2 = (0,ProductListFilterProvider/* useProductListFilterContext */.Q)(), enabledFilterOptions = ref2.enabledFilterOptions, dispatchAnalyticsEvent = ref2.dispatchAnalyticsEvent, setFilter = ref2.setFilter, clearFilters = ref2.clearFilters;
    var handlePriceChange = function(e) {
        var ref = (0,_sliced_to_array/* default */.Z)((0,priceFilter/* formatDefaultPriceRange */.Xp)(e.target.value), 2), minPrice = ref[0], maxPrice = ref[1];
        var mainCallback = function() {
            dispatchAnalyticsEvent({
                event: "refinement selected",
                params: {
                    domevent: "price",
                    domlabel: "pmax:".concat(maxPrice, ",pmin:").concat(minPrice)
                }
            });
            setFilter({
                minPrice: String(minPrice),
                maxPrice: String(maxPrice)
            });
            triggerGA4CustomEvent(props.id.toLowerCase(), "".concat(props.id.toLowerCase(), ":").concat(minPrice, "-").concat(maxPrice));
        };
        (0,splitThreadExecution/* splitThreadExecution */.K)({
            mainCallback: mainCallback
        })();
    };
    var selectedValue = ((ref1 = (ref = enabledFilterOptions["price"]) === null || ref === void 0 ? void 0 : ref.values[0]) === null || ref1 === void 0 ? void 0 : ref1.value) || undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-start",
        children: [
            selectedValue ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonClearFilter, {
                    onClick: function() {
                        return (0,priceFilter/* handleClearFilter */.wr)(props, clearFilters);
                    }
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "whitespace-nowrap w-auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "space-y-3",
                    "data-test-id": "".concat(props.id, "-filter-values"),
                    children: props.values// Show prices that have product hitCount
                    .filter(function(param) {
                        var hitCount = param.hitCount;
                        return hitCount !== 0;
                    }).map(function(param, idx) {
                        var value = param.value, label = param.label;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputRadio */.rWV, {
                            autoFocus: selectedValue === value || idx === 0,
                            name: "price",
                            id: value,
                            value: value,
                            checked: selectedValue === value,
                            onChange: handlePriceChange,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-puma-black",
                                children: label
                            })
                        }, value);
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/components/ProductListFilterDropdown.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  max-height: 50vh;\n                  overflow-y: auto;\n                "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
















var focusOnFirst = function(props) {
    var ref;
    var parent = (ref = document.activeElement) === null || ref === void 0 ? void 0 : ref.closest("#".concat(props.id, "-filter-dropdown"));
    if (!parent) return;
    var focusTargets = (0,a11y_focus/* getFocusTargets */.Zv)(parent);
    // Focus on the second item in the array since the Clear
    // button has not been removed yet
    focusTargets[1].focus();
};
var triggerGA4CustomEvent = function(refinement_attribute, refinement_selected) {
    (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
        event_name: analytics/* AnalyticsEvents.GA4EC_Refinement */._q.GA4EC_Refinement,
        event_params: {
            refinement_attribute: refinement_attribute,
            refinement_selected: refinement_selected
        }
    });
};
var ColorFilter = function(props) {
    var ref;
    var ref1 = (0,ProductListFilterProvider/* useProductListFilterContext */.Q)(), enabledFilterOptions = ref1.enabledFilterOptions, dispatchAnalyticsEvent = ref1.dispatchAnalyticsEvent, setFilter = ref1.setFilter, clearFilters = ref1.clearFilters;
    var colors = (0,useSiteConfig/* useSiteConfig */.N)().colors;
    var selectedOptions = (((ref = enabledFilterOptions[props.id]) === null || ref === void 0 ? void 0 : ref.values) || []).map(function(v) {
        return v.value;
    });
    var optionsSet = new Set(selectedOptions);
    var handleColorClick = function(e) {
        e.stopPropagation();
        var value = e.currentTarget.dataset.value;
        var mainCallback = function() {
            if (optionsSet.has(value)) {
                optionsSet.delete(value);
            } else {
                optionsSet.add(value);
            }
            if (optionsSet.size > 0) {
                setFilter((0,_define_property/* default */.Z)({}, props.id, Array.from(optionsSet).join(",")));
                triggerGA4CustomEvent(props.id.toLowerCase(), "".concat(props.id.toLowerCase(), ":").concat(value.toLowerCase()));
            } else {
                clearFilters([
                    props.id
                ]);
            }
            dispatchAnalyticsEvent({
                event: "refinement selected",
                params: {
                    domevent: props.id,
                    domlabel: Array.from(optionsSet).join("|")
                }
            });
        };
        (0,splitThreadExecution/* splitThreadExecution */.K)({
            mainCallback: mainCallback
        })();
    };
    var handleClearFilter = function() {
        focusOnFirst(props);
        clearFilters([
            props.id
        ]);
    };
    var columns = Math.min(props.values.length, 4);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-start whitespace-nowrap w-auto",
        children: [
            optionsSet.size ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonClearFilter, {
                    onClick: handleClearFilter
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                role: "group",
                className: (0,style.tw)("w-full grid gap-4 grid-cols-3", {
                    desktop: (0,style/* css */.iv)({
                        gridTemplateColumns: "repeat(".concat(columns, ", minmax(5.2rem, 1fr))")
                    })
                }),
                "data-test-id": "".concat(props.id, "-filter-values"),
                children: props.values.map(function(param, idx) {
                    var value = param.value, label = param.label, hitCount = param.hitCount;
                    var color = colors && colors[value.toLowerCase()] ? colors[value.toLowerCase()] : value.toLowerCase();
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        autoFocus: idx === 0,
                        "aria-pressed": optionsSet.has(value),
                        "data-value": value,
                        "data-test-id": "".concat(value, "-btn"),
                        className: (0,style.tw)("group focus:outline-none", {
                            "text-white": color !== "white"
                        }, "hover:text-puma-black-300 text-center whitespace-nowrap flex flex-col items-center justify-center space-y-2"),
                        onClick: handleColorClick,
                        type: "button",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "inline-flex justify-center items-center border w-9 h-9 rounded-full border border-puma-black overflow-hidden ".concat(color === "metallic" ? "bg-gradient-to-tr from-gray-600 via-gray-300 to-gray-600" : "bg-swatch-".concat(color)),
                                style: {
                                    backgroundImage: color === "multi-colored" || color === "assorted colours" ? "linear-gradient(to right top, red, orange, yellow, green, blue, violet)" : undefined
                                },
                                children: optionsSet.has(value) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "absolute group-hover:opacity-80",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                                        name: "check",
                                        size: "xl"
                                    })
                                }) : ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "block text-puma-black text-center text-sm leading-tight whitespace-nowrap capitalize",
                                children: [
                                    mapLabel(label),
                                    " (",
                                    hitCount,
                                    ")"
                                ]
                            })
                        ]
                    }, value);
                })
            })
        ]
    });
};
var CheckboxFilter = function(props) {
    var ref;
    var ref1 = (0,ProductListFilterProvider/* useProductListFilterContext */.Q)(), enabledFilterOptions = ref1.enabledFilterOptions, dispatchAnalyticsEvent = ref1.dispatchAnalyticsEvent, setFilter = ref1.setFilter, clearFilters = ref1.clearFilters;
    var selectedOptions = (((ref = enabledFilterOptions[props.id]) === null || ref === void 0 ? void 0 : ref.values) || []).map(function(v) {
        return v.value;
    });
    var optionsSet = new Set(selectedOptions);
    var handleCheckboxChange = function(e) {
        var ref;
        e.stopPropagation();
        var checked = e.target.checked;
        var value = e.target.value;
        var label = (ref = props.label) === null || ref === void 0 ? void 0 : ref.toLowerCase();
        var id = props.id;
        var mainCallback = function() {
            if (checked) {
                optionsSet.add(value);
                triggerGA4CustomEvent(label, "".concat(label, ":").concat(value === null || value === void 0 ? void 0 : value.toLowerCase()));
            } else {
                optionsSet.delete(value);
            }
            if (optionsSet.size > 0) {
                setFilter((0,_define_property/* default */.Z)({}, id, Array.from(optionsSet).join(",")));
            } else {
                clearFilters([
                    id
                ]);
            }
            dispatchAnalyticsEvent({
                event: "refinement selected",
                params: {
                    domevent: id,
                    domlabel: Array.from(optionsSet).join("|")
                }
            });
        };
        (0,splitThreadExecution/* splitThreadExecution */.K)({
            mainCallback: mainCallback
        })();
    };
    var handleClearFilter = function() {
        focusOnFirst(props);
        clearFilters([
            props.id
        ]);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-start whitespace-nowrap w-auto",
        children: [
            selectedOptions.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonClearFilter, {
                    onClick: handleClearFilter
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                role: "group",
                className: "space-y-3",
                "data-test-id": "".concat(props.id, "-filter-values"),
                children: props.values.map(function(param, idx) {
                    var value = param.value, label = param.label, hitCount = param.hitCount;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* InputCheckbox */.o2J, {
                        autoFocus: idx === 0,
                        value: value,
                        id: "".concat(props.id, "-").concat(value),
                        checked: selectedOptions.includes(value),
                        onChange: handleCheckboxChange,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-puma-black text-base",
                                children: "".concat(label)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "ml-1 tracking-widest text-puma-black-300 text-base",
                                children: [
                                    "[",
                                    "".concat(hitCount),
                                    "]"
                                ]
                            })
                        ]
                    }, value);
                })
            })
        ]
    });
};
var SizeFilter = function(props) {
    var ref;
    var ref1 = (0,ProductListFilterProvider/* useProductListFilterContext */.Q)(), enabledFilterOptions = ref1.enabledFilterOptions, dispatchAnalyticsEvent = ref1.dispatchAnalyticsEvent, setFilter = ref1.setFilter, clearFilters = ref1.clearFilters;
    var selectedOptions = (((ref = enabledFilterOptions[props.id]) === null || ref === void 0 ? void 0 : ref.values) || []).map(function(v) {
        return v.value;
    });
    var optionsSet = new Set(selectedOptions);
    var handleSizeClick = function(e) {
        e.stopPropagation();
        var value = e.currentTarget.dataset.value;
        var mainCallback = function() {
            if (optionsSet.has(value)) {
                optionsSet.delete(value);
            } else {
                optionsSet.add(value);
            }
            if (optionsSet.size > 0) {
                triggerGA4CustomEvent(props.id.toLowerCase(), "".concat(props.id.toLowerCase(), ":").concat(value.toLowerCase()));
                setFilter((0,_define_property/* default */.Z)({}, props.id, Array.from(optionsSet).join(",")));
            } else {
                clearFilters([
                    props.id
                ]);
            }
            dispatchAnalyticsEvent({
                event: "refinement selected",
                params: {
                    domevent: props.id,
                    domlabel: Array.from(optionsSet).join("|")
                }
            });
        };
        (0,splitThreadExecution/* splitThreadExecution */.K)({
            mainCallback: mainCallback
        })();
    };
    var handleClearFilter = function() {
        focusOnFirst(props);
        clearFilters([
            props.id
        ]);
    };
    var xsColumns = Math.min(props.values.length, 4);
    var lgColumns = Math.min(props.values.length, 6);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-start whitespace-nowrap w-auto",
        children: [
            optionsSet.size ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonClearFilter, {
                    onClick: handleClearFilter
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                role: "group",
                className: (0,style.tw)("w-full grid gap-1.5 grid ", (0,style/* css */.iv)({
                    gridTemplateColumns: "repeat(".concat(xsColumns, ", minmax(4rem, 1fr))")
                }), {
                    desktop: (0,style/* css */.iv)({
                        gridTemplateColumns: "repeat(".concat(lgColumns, ", minmax(4rem, 1fr))")
                    })
                }),
                "data-test-id": "".concat(props.id, "-filter-values"),
                children: props.values.map(function(param, idx) {
                    var value = param.value, label = param.label;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        autoFocus: idx === 0,
                        "data-value": value,
                        "data-test-id": "".concat(value, "-btn"),
                        "aria-pressed": optionsSet.has(value),
                        className: "border tablet:hover:border-puma-black desktop:hover:border-puma-black focus:outline-none focus-visible:outline-none text-sm whitespace-nowrap flex items-center justify-center px-2 py-2 ".concat(optionsSet.has(value) ? "border-puma-black" : "border-puma-black-500"),
                        onClick: handleSizeClick,
                        type: "button",
                        children: label
                    }, value);
                })
            })
        ]
    });
};
var ButtonClearFilter = function(param) {
    var onClick = param.onClick;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var handleOnClick = function() {
        (0,splitThreadExecution/* splitThreadExecution */.K)({
            mainCallback: onClick
        })();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        className: "mb-5 focus:outline-none\n    flex-none relative pl-2 pr-7 py-1 -ml-2 text-puma-black capitalize text-xs\n    uppercase tracking-wide font-bold whitespace-nowrap cursor-pointer",
        onClick: handleOnClick,
        type: "button",
        children: [
            t("clear"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "absolute right-2 mt-px w-4 top-2/4 -translate-y-1/2",
                "aria-hidden": true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                    name: "close-outline",
                    size: "lg",
                    color: "muted"
                })
            })
        ]
    });
};
var getFilterComponent = function(param) {
    var data = param.data, isFromDrawer = param.isFromDrawer;
    switch(data.id){
        case products/* wellKnownFilterIds.color */.g0.color:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorFilter, (0,_object_spread/* default */.Z)({}, data));
        case products/* wellKnownFilterIds.size */.g0.size:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeFilter, (0,_object_spread/* default */.Z)({}, data));
        case products/* wellKnownFilterIds.minMaxPriceRange */.g0.minMaxPriceRange:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PriceFilterSlider, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                isFromDrawer: isFromDrawer
            }));
        case products/* wellKnownFilterIds.price */.g0.price:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceFilter, (0,_object_spread/* default */.Z)({}, data));
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxFilter, (0,_object_spread/* default */.Z)({}, data));
    }
};
var dropdownTrigger = (0,style/* style */.oB)({
    base: "flex gap-2 items-center h-10 px-3 rounded-sm border hover:border-neutral-100 text-base font-bold focus:outline-none focus-within:(border-neutral-100 ring)",
    variants: {
        enabled: {
            true: "border-puma-black",
            false: "border-puma-black-500"
        },
        open: {
            true: ""
        }
    }
});
var ProductListFilterDropdown = function(param) {
    var data = param.data, openFilter = param.openFilter, setOpenFilter = param.setOpenFilter, classNames = param.classNames;
    var ref;
    var ref1 = (0,react.useRef)(null);
    var triggerRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(false), isDropdownOpen = ref2[0], setOpen = ref2[1];
    var enabledFilterOptions = (0,ProductListFilterProvider/* useProductListFilterContext */.Q)().enabledFilterOptions;
    (0,a11y/* useDialogDismiss */.sH)({
        ref: ref1,
        external: triggerRef,
        handler: function() {
            return setOpenFilter(null);
        }
    });
    (0,a11y/* useFocusTrap */.P5)({
        ref: ref1,
        isActive: openFilter !== null
    });
    (0,react.useEffect)(function() {
        if (openFilter !== data.id && isDropdownOpen) {
            var ref;
            (ref = triggerRef.current) === null || ref === void 0 ? void 0 : ref.focus();
            setOpen(false);
        } else if (data.id === openFilter) {
            setOpen(true);
        }
    }, [
        setOpen,
        isDropdownOpen,
        openFilter,
        data.id
    ]);
    var hasFilterSelected = (((ref = enabledFilterOptions[data.id]) === null || ref === void 0 ? void 0 : ref.values) || []).length > 0 || isDropdownOpen;
    var handleFilterClick = function() {
        if (isDropdownOpen) {
            setOpenFilter(null);
        } else {
            setOpenFilter(data.id);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,style.tw)("relative", classNames),
        "data-test-id": "".concat(data.id, "-filter-pill"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                ref: triggerRef,
                "aria-haspopup": "true",
                "aria-expanded": isDropdownOpen,
                "aria-controls": "".concat(data.id, "-filter-dropdown"),
                className: (0,style.tw)("whitespace-nowrap relative", dropdownTrigger({
                    enabled: hasFilterSelected,
                    open: isDropdownOpen
                })),
                onClick: handleFilterClick,
                type: "button",
                children: [
                    data.label,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (0,style.tw)(isDropdownOpen && "rotate-180"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                            name: "chevron-down",
                            size: "2xl"
                        })
                    })
                ]
            }),
            openFilter === data.id && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: ref1,
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "".concat(data.id, "-dropdown-title"),
                tabIndex: -1,
                "data-test-id": "".concat(data.id, "-filter-dropdown"),
                className: "absolute bottom-0 left-0 transform translate-y-full z-20 whitespace-nowrap focus:outline-none min-w-64",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,style.tw)("relative bg-white pt-1 shadow-xl border mt-2 border-puma-black-500 text-base", {
                        desktop: (0,style/* css */.iv)(_templateObject())
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "-mt-1 p-2 text-right flex justify-end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* default */.Z, {
                                onClick: handleFilterClick,
                                size: "sm"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "p-6 pt-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                    "data-test-id": "".concat(data.id, "-dropdown-title"),
                                    className: "sr-only",
                                    children: [
                                        data.label,
                                        " Filter"
                                    ]
                                }),
                                getFilterComponent({
                                    data: data,
                                    isFromDrawer: false
                                })
                            ]
                        })
                    ]
                })
            }, "".concat(data.id, "-dropdown"))
        ]
    });
};


/***/ }),

/***/ 64648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ useProductListFilterContext; },
/* harmony export */   "w": function() { return /* binding */ ProductListFilterProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(17599);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31373);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5341);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var utils_productFilters__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(49341);
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83168);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20368);
/* harmony import */ var utils_priceFilter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27523);
/* harmony import */ var utils_products__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1032);
/* harmony import */ var hooks_usePageEventsContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43308);














var priceRangeInitialState = {
    max: "",
    min: ""
};
var ProductListFilterContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    queryParams: {},
    enabledFilterOptions: {},
    enabledFilters: [],
    setSortOrder: function() {
        return null;
    },
    setFilter: function() {
        return null;
    },
    removeFilterValue: function() {
        return null;
    },
    clearFilters: function() {
        return null;
    },
    clearAllFilters: function() {
        return null;
    },
    dispatchAnalyticsEvent: function() {
        return null;
    },
    totalCount: 0,
    isFetching: false,
    noResults: false,
    priceRange: priceRangeInitialState,
    setPriceRange: function() {
        return null;
    },
    filterItemsCache: [],
    setFilterItemsCache: function() {
        return null;
    },
    defaultPriceRange: priceRangeInitialState,
    queryParamsPriceRange: [],
    handlePriceSliderSubmit: function() {
        return null;
    }
});
var ProductListFilterProvider = function(param) {
    var noResults = param.noResults, filteringOptions = param.filteringOptions, totalCount = param.totalCount, isFetching = param.isFetching, children = param.children;
    var ref, ref1;
    var ref2 = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_4__/* .useSiteConfig */ .N)(), resetSearchConditionsOptions = ref2.resetSearchConditionsOptions, currency = ref2.currency;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var pageviewEventHasFired = (0,hooks_usePageEventsContext__WEBPACK_IMPORTED_MODULE_7__/* .usePageEventsContext */ .qN)().pageviewEventHasFired;
    var routeShards = router.asPath.split("?");
    var queryString = (routeShards === null || routeShards === void 0 ? void 0 : routeShards[1]) || "";
    var newQueryParams = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return new URLSearchParams(queryString);
    }, [
        queryString
    ]);
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(priceRangeInitialState), priceRange = ref3[0], setPriceRange = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(filteringOptions), filterItemsCache = ref4[0], setFilterItemsCache = ref4[1];
    var minMaxPriceFilterOption = filterItemsCache.filter(function(item) {
        return item.id === utils_products__WEBPACK_IMPORTED_MODULE_6__/* .wellKnownFilterIds.minMaxPriceRange */ .g0.minMaxPriceRange;
    })[0];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((0,utils_priceFilter__WEBPACK_IMPORTED_MODULE_5__/* .getDefaultPriceRange */ .FU)(minMaxPriceFilterOption)), defaultPriceRange = ref5[0], setDefaultPriceRange = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((0,utils_priceFilter__WEBPACK_IMPORTED_MODULE_5__/* .getDefaultPriceRange */ .FU)(minMaxPriceFilterOption)), defaultValueClearPriceFilter = ref6[0];
    var queryParams = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return Array.from(newQueryParams).reduce(function(result, param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
            result[key] = value;
            return result;
        }, {});
    }, [
        newQueryParams
    ]);
    var validFilters = (0,utils_productFilters__WEBPACK_IMPORTED_MODULE_9__/* .decodeFilters */ .id)(queryParams);
    var enabledFilters = Object.keys(validFilters).reduce(function(result, param) {
        if (param === "minPrice" || param === "maxPrice") {
            if (result.includes("price")) return result;
            result.push("price");
        } else {
            result.push(param);
        }
        return result;
    }, []);
    var enabledFilterParams = enabledFilters.reduce(function(result, key) {
        if (key === "price") {
            result[key] = [
                "(".concat(validFilters["minPrice"], "..").concat(validFilters["maxPrice"], ")"), 
            ];
        } else {
            result[key] = validFilters[key].split(",");
        }
        return result;
    }, {});
    var queryParamsPriceRange = (0,utils_priceFilter__WEBPACK_IMPORTED_MODULE_5__/* .formatDefaultPriceRange */ .Xp)(enabledFilterParams === null || enabledFilterParams === void 0 ? void 0 : (ref = enabledFilterParams["price"]) === null || ref === void 0 ? void 0 : ref[0]);
    // save the filtering options to use when the total count is 0 and ther's no filters on the query response.
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (totalCount === 0) return;
        setFilterItemsCache(filteringOptions);
    }, [
        filteringOptions,
        totalCount
    ]);
    // sets the default initial price range and after filters changed (size, color)
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setDefaultPriceRange((0,utils_priceFilter__WEBPACK_IMPORTED_MODULE_5__/* .getDefaultPriceRange */ .FU)(minMaxPriceFilterOption));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(minMaxPriceFilterOption)
    ]);
    // we use the query params as source of truth but only when there's of the priceSlider, but only if is not out of the default range
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var priceMin = (0,utils_priceFilter__WEBPACK_IMPORTED_MODULE_5__/* .paramsOrPriceRange_Min */ .rW)({
            queryParamsPriceRange: queryParamsPriceRange,
            priceRange: priceRange
        });
        var priceMax = (0,utils_priceFilter__WEBPACK_IMPORTED_MODULE_5__/* .paramsOrPriceRange_Max */ .x$)({
            queryParamsPriceRange: queryParamsPriceRange,
            priceRange: priceRange
        });
        var priceRangeIsOutOfTheDefaultRange = priceMax > Number(defaultPriceRange.max || 0) || priceMin < Number(defaultPriceRange.min || 0);
        if (queryParamsPriceRange && !priceRangeIsOutOfTheDefaultRange) {
            setPriceRange({
                min: String(priceMin),
                max: String(priceMax)
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        router.asPath,
        JSON.stringify(defaultPriceRange)
    ]);
    var minMaxPriceRangeValue = minMaxPriceFilterOption === null || minMaxPriceFilterOption === void 0 ? void 0 : minMaxPriceFilterOption.values[minMaxPriceFilterOption.values.length - 1];
    var isPriceLabelAndParamsMatching = (0,utils_priceFilter__WEBPACK_IMPORTED_MODULE_5__/* .validatePriceFilterLabel */ .l6)(minMaxPriceRangeValue === null || minMaxPriceRangeValue === void 0 ? void 0 : minMaxPriceRangeValue.label, enabledFilterParams === null || enabledFilterParams === void 0 ? void 0 : (ref1 = enabledFilterParams["price"]) === null || ref1 === void 0 ? void 0 : ref1[0]);
    var enabledFilterOptions = filterItemsCache.filter(function(v) {
        return v !== null;
    }).reduce(function(result, filter) {
        if (!enabledFilters.includes(filter.id)) return result;
        result[filter.id] = {
            id: filter.id,
            label: filter.label,
            values: filter.id === "price" && minMaxPriceFilterOption && isPriceLabelAndParamsMatching ? [
                minMaxPriceRangeValue
            ] : enabledFilterParams[filter.id].map(function(v) {
                return filter.values.find(function(param) {
                    var value = param.value;
                    return value === v;
                }) || false;
            }).filter(Boolean)
        };
        return result;
    }, {});
    var clearAllFilters = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var routePath = routeShards[0];
        setPriceRange(defaultValueClearPriceFilter);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // dont clear params like sort, search query and offset
            for(var _iterator = Array.from(newQueryParams)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_step.value, 1), key = _value[0];
                if ((0,utils_productFilters__WEBPACK_IMPORTED_MODULE_9__/* .isValidFilter */ .RF)(key)) {
                    newQueryParams.delete(key);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // convert to string
        var newQueryParamsStr = newQueryParams.toString();
        var routeParams = newQueryParamsStr.length > 0 ? "?".concat(newQueryParamsStr) : "";
        var ref;
        // replace route
        router.replace("".concat(routePath).concat(routeParams), undefined, {
            scroll: (ref = resetSearchConditionsOptions === null || resetSearchConditionsOptions === void 0 ? void 0 : resetSearchConditionsOptions.isRouterScrollEnabled) !== null && ref !== void 0 ? ref : false
        });
    }, [
        routeShards,
        defaultValueClearPriceFilter,
        newQueryParams,
        router,
        resetSearchConditionsOptions === null || resetSearchConditionsOptions === void 0 ? void 0 : resetSearchConditionsOptions.isRouterScrollEnabled, 
    ]);
    var dispatchAnalyticsEvent = function(param) {
        var event = param.event, params = param.params;
        (0,utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* .event */ .B)(event, params);
    };
    var setSortOrder = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        var _query = router.query, _o = _query.offset, nonOffsetQuerystrings = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_query, [
            "offset"
        ]);
        var query = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, nonOffsetQuerystrings), {
            sort: value
        });
        router.push({
            query: query
        }, undefined, {
            scroll: false
        });
    }, [
        router
    ]);
    var setFilter = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(params) {
        var _query = router.query, _o = _query.offset, nonOffsetQuerystrings = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_query, [
            "offset"
        ]);
        var encodedFilters = (0,utils_productFilters__WEBPACK_IMPORTED_MODULE_9__/* .encodeFilters */ .IU)(params);
        var query = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, nonOffsetQuerystrings, encodedFilters);
        router.push({
            query: query
        }, undefined, {
            scroll: false
        });
    }, [
        router
    ]);
    var removeFilterValue = function(filter, value) {
        var filterQueryParams = [];
        if (filter === "price") {
            clearFilters([
                "minPrice",
                "maxPrice"
            ]);
            return;
        } else {
            var encodedFilterName = (0,utils_productFilters__WEBPACK_IMPORTED_MODULE_9__/* .encodeFilterName */ .lq)(filter);
            filterQueryParams = queryParams[encodedFilterName].split(",");
            var valueIndex = filterQueryParams.indexOf(value);
            filterQueryParams.splice(valueIndex, 1);
        }
        if (filterQueryParams.length === 0) {
            clearFilters([
                filter
            ]);
        } else {
            setFilter((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, filter, filterQueryParams.join(",")));
            dispatchAnalyticsEvent({
                event: "refinement selected",
                params: {
                    domevent: filter,
                    domlabel: filterQueryParams.join("|")
                }
            });
        }
    };
    var clearFilters = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(filters) {
        var _query = router.query, _o = _query.offset, nonOffsetQuerystrings = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_query, [
            "offset"
        ]);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = filters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var encodedKey = (0,utils_productFilters__WEBPACK_IMPORTED_MODULE_9__/* .encodeFilterName */ .lq)(key);
                if ([
                    "pref_minPrice",
                    "pref_maxPrice"
                ].includes(encodedKey)) {
                    setPriceRange(defaultValueClearPriceFilter);
                }
                delete nonOffsetQuerystrings[encodedKey];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        router.push({
            query: nonOffsetQuerystrings
        }, undefined, {
            scroll: false
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        router
    ]);
    var handlePriceSliderSubmit = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var minPrice = priceRange === null || priceRange === void 0 ? void 0 : priceRange.min;
        var maxPrice = priceRange === null || priceRange === void 0 ? void 0 : priceRange.max;
        var ref = (0,utils_priceFilter__WEBPACK_IMPORTED_MODULE_5__/* .get_GA4_SliderPosition */ .JF)(minPrice, maxPrice, defaultPriceRange), slider_low = ref.slider_low, slider_high = ref.slider_high, slider_range = ref.slider_range;
        if (pageviewEventHasFired) {
            (0,utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* .AnalyticsEvents.GA4_CustomEvent */ ._q.GA4_CustomEvent, {
                event_name: utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* .AnalyticsEvents.GA4EC_Refinement */ ._q.GA4EC_Refinement,
                event_params: {
                    refinement_attribute: "price",
                    refinement_selected: "undefined",
                    price_low: minPrice,
                    price_high: maxPrice,
                    min_price: defaultPriceRange.min,
                    max_price: defaultPriceRange.max,
                    slider_low: slider_low,
                    slider_high: slider_high,
                    slider_range: slider_range,
                    slider_currency: currency === null || currency === void 0 ? void 0 : currency.code
                }
            });
        }
        setFilter({
            minPrice: minPrice,
            maxPrice: maxPrice
        });
    }, [
        currency === null || currency === void 0 ? void 0 : currency.code,
        defaultPriceRange,
        pageviewEventHasFired,
        priceRange === null || priceRange === void 0 ? void 0 : priceRange.max,
        priceRange === null || priceRange === void 0 ? void 0 : priceRange.min,
        setFilter, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductListFilterContext.Provider, {
        value: {
            queryParams: queryParams,
            enabledFilterOptions: enabledFilterOptions,
            removeFilterValue: removeFilterValue,
            enabledFilters: enabledFilters,
            clearAllFilters: clearAllFilters,
            clearFilters: clearFilters,
            setFilter: setFilter,
            setSortOrder: setSortOrder,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            totalCount: totalCount,
            isFetching: isFetching,
            noResults: noResults,
            priceRange: priceRange,
            setPriceRange: setPriceRange,
            defaultPriceRange: defaultPriceRange,
            queryParamsPriceRange: queryParamsPriceRange,
            filterItemsCache: filterItemsCache,
            setFilterItemsCache: setFilterItemsCache,
            handlePriceSliderSubmit: handlePriceSliderSubmit
        },
        children: children
    });
};
var useProductListFilterContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(ProductListFilterContext);
};


/***/ }),

/***/ 4291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ ProductListItem; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./__generated__/graphql.ts
var graphql = __webpack_require__(37678);
// EXTERNAL MODULE: ./ui/components/ProductBadge.tsx + 1 modules
var ProductBadge = __webpack_require__(10395);
// EXTERNAL MODULE: ./hooks/useScreenSize.ts
var useScreenSize = __webpack_require__(32629);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./ui/components/ProductPromotions.tsx
var ProductPromotions = __webpack_require__(7681);
// EXTERNAL MODULE: ./ui/components/ProductListItemImages.tsx
var ProductListItemImages = __webpack_require__(45876);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/hooks/esm/index.js
var esm = __webpack_require__(68138);
// EXTERNAL MODULE: ../node_modules/twind/twind.js + 1 modules
var twind = __webpack_require__(34209);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var elements_esm = __webpack_require__(12601);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./utils/image.ts
var utils_image = __webpack_require__(75350);
// EXTERNAL MODULE: ./hooks/usePageEventsContext.tsx
var usePageEventsContext = __webpack_require__(43308);
// EXTERNAL MODULE: ./utils/analytics/index.ts + 6 modules
var analytics = __webpack_require__(83168);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
;// CONCATENATED MODULE: ./ui/components/DirectionButton.tsx




var DirectionButton = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        "aria-label": props.label,
        onClick: props.onClick,
        disabled: props.disabled,
        className: (0,twind.tw)("mobile:invisible opacity-0 group-hover:opacity-100 absolute top-1/2 transform -translate-y-1/2 w-8 h-8 p-1 items-center justify-center rounded-full bg-white text-puma-black-200\n        disabled:text-opacity-20 disabled:cursor-default", "".concat(props.direction, "-2")),
        type: "button",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_esm/* Icon */.JO$, {
            name: props.direction === "left" ? "chevron-left" : "chevron-right"
        })
    });
};
var RightButton = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectionButton, (0,_object_spread/* default */.Z)({
        direction: "right"
    }, props));
};
var LeftButton = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectionButton, (0,_object_spread/* default */.Z)({
        direction: "left"
    }, props));
};

// EXTERNAL MODULE: ./ui/components/Skeleton.tsx
var Skeleton = __webpack_require__(98463);
;// CONCATENATED MODULE: ./ui/components/ProductListItemVariants.tsx










var ProductListItemVariants = function(props) {
    var ref;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var variantImageContainer = (0,esm/* useHorizontalScroll */.mZ)({
        infinite: false
    });
    var numberOfVariants = props.master.orderableColorCount || ((ref = props.variations) === null || ref === void 0 ? void 0 : ref.length) || 1;
    var moreThanOneVariant = numberOfVariants > 1;
    var pageviewEventHasFired = (0,usePageEventsContext/* usePageEventsContext */.qN)().pageviewEventHasFired;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative h-12 mobile:h-10 flex items-center group",
        "data-test-id": "colors-hover-data-test-id",
        onClick: function(event) {
            if (moreThanOneVariant) {
                // prevent click events from triggering the parent link
                event.preventDefault();
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: (0,twind.tw)(moreThanOneVariant && "group-hover:hidden group-focus-within:hidden", "text-puma-black-300 uppercase text-xs whitespace-nowrap flex items-center"),
                children: [
                    numberOfVariants,
                    " ",
                    t(moreThanOneVariant ? "colors" : "color"),
                    moreThanOneVariant && /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_esm/* Icon */.JO$, {
                        className: "sm:hidden ml-1 text-neutral-60",
                        name: "chevron-down",
                        size: "base"
                    })
                ]
            }),
            moreThanOneVariant && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,twind.tw)("invisible group-hover:visible group-focus-within:visible flex relative w-full items-center justify-center z-[5]"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        role: "group",
                        ref: variantImageContainer.ref,
                        className: "flex w-8/12 overflow-x-auto scroll-snap !no-scrollbars",
                        "aria-label": t("colorVariation".concat(moreThanOneVariant && "s")),
                        children: Array.from({
                            length: numberOfVariants
                        }).map(function(_, idx) {
                            var ref, ref1, ref2;
                            var variation = (ref = props.variations) === null || ref === void 0 ? void 0 : ref[idx];
                            if (!variation) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
                                    className: "w-1/4 flex-none last-child:mr-auto first-child:ml-auto aspect-1-1 rounded-none",
                                    delay: "".concat((idx + 1) * 100, "ms")
                                }, idx);
                            }
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                "aria-pressed": variation.colorValue === props.variant.colorValue,
                                "aria-label": "".concat(t("preview"), " ").concat(variation.colorName),
                                className: "w-1/4 flex-none last-child:mr-auto first-child:ml-auto",
                                onClick: function() {
                                    props.select(variation.colorValue);
                                    if (pageviewEventHasFired) {
                                        (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
                                            event_name: "swatch_click",
                                            event_params: {
                                                item_id_ep: variation.id,
                                                item_name_ep: variation.name,
                                                color_code_ep: (0,analytics/* addPrefixToAnalyticProp */.lL)(variation.colorValue)
                                            }
                                        });
                                    }
                                },
                                type: "button",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    alt: "".concat(variation.name, " - ").concat(variation.colorName),
                                    className: (0,twind.tw)("block w-full border", variation.colorValue === ((ref1 = props.variant) === null || ref1 === void 0 ? void 0 : ref1.colorValue) ? "border-neutral-70" : "border-white"),
                                    loading: "lazy",
                                    width: "100",
                                    height: "100",
                                    src: (0,utils_image/* resizeProductImage */.QW)((ref2 = variation.images[0]) === null || ref2 === void 0 ? void 0 : ref2.href, 100).replace("fafafa", "ffffff")
                                })
                            }, idx);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftButton, {
                        onClick: variantImageContainer.scrollToPrev,
                        disabled: !variantImageContainer.hasPrev,
                        label: t("scrollLeft")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RightButton, {
                        onClick: variantImageContainer.scrollToNext,
                        disabled: !variantImageContainer.hasNext,
                        label: t("scrollRight")
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
// EXTERNAL MODULE: ./ui/components/StarRating.tsx
var StarRating = __webpack_require__(98567);
;// CONCATENATED MODULE: ./ui/components/ProductListItemRating.tsx





var ProductListItemRating = function(props) {
    var t = (0,useTranslations/* useTranslate */.qM)();
    var showRatingsAndReviews = (0,useFeature/* useFeature */.S)("RATINGS_AND_REVIEWS");
    var score = props.master.score;
    var ref = (0,useSiteConfig/* useSiteConfig */.N)(), isPNARegion = ref.staticFeatures.isPNARegion;
    return (score === null || score === void 0 ? void 0 : score.rating) && (score === null || score === void 0 ? void 0 : score.amount) && showRatingsAndReviews && !isPNARegion ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center",
        "data-test-id": "plp-star-rating",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "sr-only",
                children: t("reviewRating")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StarRating/* StarRating */.Z, {
                rating: score.rating
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "ml-1 pl-px text-sm",
                children: [
                    "(",
                    score.amount,
                    ")",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "sr-only",
                        children: t("reviews")
                    })
                ]
            })
        ]
    }) : null;
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ./ui/elements/Link.tsx
var Link = __webpack_require__(68302);
// EXTERNAL MODULE: ./utils/buildProductUrl.ts
var buildProductUrl = __webpack_require__(69377);
// EXTERNAL MODULE: ./utils/locale.ts + 1 modules
var utils_locale = __webpack_require__(79302);
// EXTERNAL MODULE: ./hooks/useProductClickHandling.ts
var useProductClickHandling = __webpack_require__(7362);
// EXTERNAL MODULE: ./hooks/useGA4Events.tsx
var useGA4Events = __webpack_require__(89113);
// EXTERNAL MODULE: ./utils/ga4Items.ts
var ga4Items = __webpack_require__(54093);
// EXTERNAL MODULE: ./utils/referrerParametersUtils.ts
var referrerParametersUtils = __webpack_require__(74067);
;// CONCATENATED MODULE: ./ui/components/ProductListItemLink.tsx

















var ProductListItemLink = function(param) {
    var master = param.master, variant = param.variant, children = param.children, position = param.position, categoryId = param.categoryId, itemListId = param.itemListId, itemListName = param.itemListName, fromRecommender = param.fromRecommender;
    var ref;
    var router = (0,next_router.useRouter)();
    var search = router.pathname.endsWith("/search");
    var ref1 = (0,useSiteConfig/* useSiteConfig */.N)(), currency = ref1.currency, locale = ref1.locale;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useTrackRecommendationClickMutation */.jNL)(), 2), trackRecommendationClick = ref2[1];
    var hasSentAnalytics = (0,react.useRef)(false);
    var t = (0,useTranslations/* useTranslate */.qM)();
    var id = master.id;
    var name = variant.name || master.name;
    var color = variant.colorValue;
    var itemId = "".concat(id, "_").concat(color);
    var href = (0,buildProductUrl/* buildProductUrl */.B)(id, name, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, search && {
        search: true
    }), {
        color: color
    }));
    var categoryUrl = (ref = (0,utils_locale/* removeLocalePrefix */.g5)(router.asPath, locale).split("?")) === null || ref === void 0 ? void 0 : ref[0];
    var setProduct = (0,useGA4Events/* useGA4Events */.tL)().setProduct;
    // To differentiate in which ProductListItemLink the click occurred.
    var setIsProductClicked = (0,useProductClickHandling/* useProductClickHandling */.g)(itemId);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
        "data-test-id": "product-list-item-link",
        href: href,
        "aria-label": "".concat(t("goTo"), " ").concat(master.name, " ").concat(variant.colorName),
        onClick: function(e) {
            var ref;
            if (categoryId) (0,referrerParametersUtils/* setReferrerCategory */.ns)(categoryId);
            if ((e === null || e === void 0 ? void 0 : e.target).closest("button")) {
                e.preventDefault();
                return;
            }
            if (fromRecommender) {
                trackRecommendationClick({
                    masterId: variant.masterId,
                    swatch: variant.colorValue,
                    recommenderId: fromRecommender.recommenderId,
                    recommenderName: fromRecommender.recommenderName
                });
                (0,analytics/* event */.B)(analytics/* AnalyticsEvents.PRODUCT_RECOMMENDER_CLICKED */._q.PRODUCT_RECOMMENDER_CLICKED, {
                    ecommerce: {
                        productRecommenderLocation: categoryUrl,
                        recommenderName: fromRecommender === null || fromRecommender === void 0 ? void 0 : fromRecommender.recommenderName,
                        productName: name,
                        productSku: variant.id
                    }
                });
            }
            hasSentAnalytics.current = true;
            (0,analytics/* event */.B)(analytics/* AnalyticsEvents.PRODUCT_CLICKED */._q.PRODUCT_CLICKED, {
                ecommerce: {
                    currencyCode: currency.code,
                    click: {
                        actionField: {
                            list: search ? "internal search" : categoryUrl
                        },
                        products: [
                            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,analytics/* transformProductToAnalyticsProduct */.vA)({
                                product: master,
                                variant: variant
                            })), {
                                category: categoryId || ((ref = master.category) === null || ref === void 0 ? void 0 : ref.id) || "",
                                list: search ? "internal search" : categoryUrl,
                                position: position
                            }), 
                        ]
                    }
                }
            });
            (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4_CustomEvent */._q.GA4_CustomEvent, {
                event_name: analytics/* AnalyticsEvents.PRODUCT_DISCOVERY_CHANNEL */._q.PRODUCT_DISCOVERY_CHANNEL,
                event_params: {
                    item_id_ep: variant.id,
                    item_name_ep: variant.name
                }
            });
            localStorage.setItem("productClickedPlpUrl", categoryUrl);
            var newGa4Item = {
                lid: itemListId,
                lname: itemListName,
                idx: position - 1
            };
            var storedPromotion = window.sessionStorage.getItem("last-clicked-promotion");
            var promotion = storedPromotion !== null ? JSON.parse(storedPromotion) : undefined;
            if (promotion) {
                newGa4Item = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, newGa4Item), {
                    cslot: promotion.creativeSlot,
                    cname: promotion.creativeName,
                    pid: promotion.promotionId,
                    pname: promotion.promotionName
                });
            }
            (0,ga4Items/* setGa4ItemInMap */.HH)("".concat(id, "_").concat(color), newGa4Item);
            setProduct(variant);
            setIsProductClicked(true);
        },
        children: children
    });
};

// EXTERNAL MODULE: ./ui/components/ProductPrice/ProductPrice.tsx + 3 modules
var ProductPrice = __webpack_require__(1108);
;// CONCATENATED MODULE: ./ui/components/ProductListItemInformation.tsx




var ProductListItemInformation = function(props) {
    var ref, ref1, ref2, ref3;
    var ref4 = (0,useSiteConfig/* useSiteConfig */.N)(), showHeaderSubHeaderProductDetail = ref4.staticFeatures.showHeaderSubHeaderProductDetail;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex mobile:flex-col w-full items-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "w-full mobile:text-sm mobile:pr-0 font-bold text-base pr-5 line-clamp-2",
                        children: showHeaderSubHeaderProductDetail ? props.variant.header || props.variant.name : props.variant.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "sr-only",
                        children: props.variant.colorName
                    }),
                    showHeaderSubHeaderProductDetail && props.variant.subHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "w-full mobile:text-sm mobile:pr-0 text-base text-puma-gray-60 line-clamp-2",
                        children: props.variant.subHeader
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col flex-none mobile:items-start items-end text-sm md:text-base mobile:mt-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice/* ProductPrice */.jF, (0,_object_spread/* default */.Z)({
                    price: {
                        amount: (ref = props.variant.productPrice) === null || ref === void 0 ? void 0 : ref.price,
                        salePrice: (ref1 = props.variant.productPrice) === null || ref1 === void 0 ? void 0 : ref1.salePrice,
                        promotionPrice: (ref2 = props.variant.productPrice) === null || ref2 === void 0 ? void 0 : ref2.promotionPrice,
                        isSalePriceElapsed: (ref3 = props.variant.productPrice) === null || ref3 === void 0 ? void 0 : ref3.isSalePriceElapsed
                    },
                    compact: true
                }, ProductPrice/* PLP_PRICE_STRATEGY */.P8))
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/components/StarsRatingEmplifi.tsx


var StarsRatingEmplifi = function(param) {
    var averageRating = param.averageRating, amountOfReviews = param.amountOfReviews;
    var convertAverageRatingIntoStarsStatusObject = function(averageRating) {
        // NOTE: this way of parsing decimal numbers (1.1, 1.2, x.3, ...)
        //       (here represented as 1, 2, 3, ...) to empty (0),
        //       half-filled (0.5) or full (1) stars was extracted
        //       manually from how TurnTo internally handles stars in
        //       their widgets.
        var parseDecimalToStar = {
            1: 0,
            2: 0,
            3: 0.5,
            4: 0.5,
            5: 0.5,
            6: 0.5,
            7: 0.5,
            8: 1,
            9: 1
        };
        var numberHasDecimalPlace = averageRating - Math.floor(averageRating) !== 0;
        var decimalPartOfNumber = String(averageRating).split(".")[1];
        var showHalfStar = numberHasDecimalPlace ? parseDecimalToStar[decimalPartOfNumber] === 0.5 : false;
        var numberHasDecimalPlaceButShowFullStar = numberHasDecimalPlace && parseDecimalToStar[decimalPartOfNumber] === 1;
        return {
            filled: Math.trunc(averageRating) + (numberHasDecimalPlaceButShowFullStar ? 1 : 0),
            half: showHalfStar ? 1 : 0,
            empty: 5 - Math.trunc(averageRating) + (showHalfStar || numberHasDecimalPlaceButShowFullStar ? -1 : 0)
        };
    };
    var starsStatus = convertAverageRatingIntoStarsStatusObject(averageRating);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex space-x-1 items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex -mb-0.5",
                children: Object.keys(starsStatus).map(function(key) {
                    return Array.from(Array(starsStatus[key]).keys()).map(function(number) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_esm/* Icon */.JO$, {
                            name: "star-".concat(key),
                            className: "h-5 w-5 -mx-0.5"
                        }, number);
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "(",
                    amountOfReviews,
                    ")"
                ]
            })
        ]
    });
};
/* harmony default export */ var components_StarsRatingEmplifi = (StarsRatingEmplifi);

;// CONCATENATED MODULE: ./ui/components/ProductListItem.tsx














var ProductListItem = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = (0,react.useState)(props.color), variation = ref7[0], setVariation = ref7[1];
    var master = props.masterProduct;
    var isCompactMode = props.isCompactMode;
    var ref8 = (0,react.useState)(false), hasInteracted = ref8[0], setHasInteracted = ref8[1];
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useSiblingVariantsQuery */.I_O)({
        variables: {
            input: {
                styleNumberId: (ref = props.variantProduct) === null || ref === void 0 ? void 0 : ref.id
            }
        },
        pause: (master === null || master === void 0 ? void 0 : master.orderableColorCount) === 1 || !hasInteracted || !((ref1 = props.variantProduct) === null || ref1 === void 0 ? void 0 : ref1.id),
        requestPolicy: "cache-first"
    }), 1), variantsResult = ref9[0];
    var ref10;
    var variants = (ref10 = (ref2 = variantsResult.data) === null || ref2 === void 0 ? void 0 : ref2.siblingVariants) !== null && ref10 !== void 0 ? ref10 : [];
    var ref11;
    var variant = (ref11 = variants.find(function(v) {
        return v.colorValue === variation;
    })) !== null && ref11 !== void 0 ? ref11 : props.variantProduct;
    // get all but presale
    var soldout = variant === null || variant === void 0 ? void 0 : (ref3 = variant.displayOutOfStock) === null || ref3 === void 0 ? void 0 : ref3.soldout;
    var backsoon = variant === null || variant === void 0 ? void 0 : (ref4 = variant.displayOutOfStock) === null || ref4 === void 0 ? void 0 : ref4.backsoon;
    var comingsoon = variant === null || variant === void 0 ? void 0 : (ref5 = variant.displayOutOfStock) === null || ref5 === void 0 ? void 0 : ref5.comingsoon;
    var hasNotOrderableStatus = soldout || backsoon || comingsoon;
    var promotions = variant === null || variant === void 0 ? void 0 : variant.promotions;
    var badges = variant === null || variant === void 0 ? void 0 : variant.badges;
    var hasBonus = promotions === null || promotions === void 0 ? void 0 : promotions.length;
    var isAppExclusive = (0,react.useMemo)(function() {
        return badges === null || badges === void 0 ? void 0 : badges.some(function(badge) {
            return badge.id === "app-exclusive";
        });
    }, [
        badges
    ]);
    var cardRef = (0,react.useRef)(null);
    var screenSize = (0,useScreenSize/* useScreenSize */.e)();
    var staticFeatures = (0,useSiteConfig/* useSiteConfig */.N)().staticFeatures;
    (0,react.useEffect)(function() {
        if (cardRef && screenSize && props.onDimensionsChange) {
            var ref, ref1;
            props.onDimensionsChange("".concat(cardRef === null || cardRef === void 0 ? void 0 : (ref = cardRef.current) === null || ref === void 0 ? void 0 : ref.offsetWidth, "px"), "".concat(cardRef === null || cardRef === void 0 ? void 0 : (ref1 = cardRef.current) === null || ref1 === void 0 ? void 0 : ref1.offsetHeight, "px"));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        screenSize,
        cardRef,
        isCompactMode
    ]);
    if (!master || !variant) return null;
    var parsedAvgRating = master.averageRating || 0;
    var parsedReviewsCount = master.amountOfReviews || 0;
    var shouldDisplayRatingStars = staticFeatures.isPNARegion && !props.disableRatings && parsedAvgRating > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        "data-test-id": "product-list-item",
        "data-product-id": (ref6 = props.variantProduct) === null || ref6 === void 0 ? void 0 : ref6.id,
        "data-from-recommender": props.fromRecommender ? props.fromRecommender.recommenderId : null,
        onMouseEnter: function() {
            setHasInteracted(true);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListItemLink, {
            master: master,
            variant: variant,
            categoryId: props.categoryId,
            fromRecommender: props.fromRecommender,
            position: props.position,
            itemListId: (props === null || props === void 0 ? void 0 : props.search) ? props === null || props === void 0 ? void 0 : props.search : props.itemListId,
            itemListName: (props === null || props === void 0 ? void 0 : props.search) ? props === null || props === void 0 ? void 0 : props.search : props.itemListName,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative w-full flex flex-col gap-2",
                "data-primary-product": !hasNotOrderableStatus && !isAppExclusive && !hasBonus,
                ref: cardRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListItemImages/* ProductListItemImages */.X, {
                        variant: variant,
                        position: props.position
                    }),
                    staticFeatures.isPNARegion && shouldDisplayRatingStars && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_StarsRatingEmplifi, {
                        amountOfReviews: parsedReviewsCount,
                        averageRating: parsedAvgRating
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListItemVariants, {
                        master: master,
                        variations: variants,
                        variant: variant,
                        select: setVariation
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListItemInformation, {
                        variant: variant
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPromotions/* ProductPromotions */._, {
                        variant: variant,
                        compact: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductBadge/* ProductBadges */.aS, {
                        variant: variant
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListItemRating, {
                        master: master
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductBadge/* SaleBadge */.fD, {
                        variant: variant
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 7681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ ProductPromotions; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var utils_isNotNullish__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50597);
/* harmony import */ var _elements_SafeHtml__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99671);




var ProductPromotion = function(props) {
    var ref;
    return ((ref = props.promotion) === null || ref === void 0 ? void 0 : ref.calloutMessage) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_SafeHtml__WEBPACK_IMPORTED_MODULE_2__/* .SafeHtml */ .T, {
        html: props.promotion.calloutMessage,
        as: "p",
        className: "text-red-600 font-bold",
        "data-test-id": "promotion-callout-message"
    }) : null;
};
var ProductPromotions = function(props) {
    var ref, ref1, ref2, ref3;
    var promotions = (ref = props.variant) === null || ref === void 0 ? void 0 : (ref1 = ref.promotions) === null || ref1 === void 0 ? void 0 : ref1.filter(utils_isNotNullish__WEBPACK_IMPORTED_MODULE_3__/* .isNotNullish */ .l);
    var displayOutOfStock = (ref2 = props.variant) === null || ref2 === void 0 ? void 0 : ref2.displayOutOfStock;
    return ((ref3 = props.variant) === null || ref3 === void 0 ? void 0 : ref3.orderable) && !(displayOutOfStock === null || displayOutOfStock === void 0 ? void 0 : displayOutOfStock.comingsoon) && (promotions === null || promotions === void 0 ? void 0 : promotions.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: props.compact ? "text-xs" : "space-y-2",
        children: promotions.map(function(promo) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductPromotion, {
                promotion: promo
            }, promo.id);
        })
    }) : null;
};


/***/ }),

/***/ 98567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ StarRating; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3204);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var twind__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34209);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77480);
/* harmony import */ var utils_scroll_to__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41403);
/* harmony import */ var utils_isNumber__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95442);








var StarRating = function(props) {
    var rating = Number(props.rating);
    return (0,utils_isNumber__WEBPACK_IMPORTED_MODULE_4__/* .isNumber */ .h)(rating) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            !props.pageAnchorId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StarRatingSRLabel, {
                rating: rating
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                role: "presentation",
                className: "flex items-center text-puma-black-500",
                "data-test-id": props.dataTestId,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex relative",
                    children: [
                        (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(Array(5)).map(function(_, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO$, {
                                name: "star-empty",
                                className: "flex-shrink-0",
                                size: "2xl"
                            }, "first-rating-".concat(i));
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (0,twind__WEBPACK_IMPORTED_MODULE_6__.tw)("flex absolute overflow-hidden text-puma-black top-0", "w-[".concat(Math.round(rating / 5 * 100), "%]")),
                            children: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(Array(5)).map(function(_, i) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO$, {
                                    name: "star-filled",
                                    className: "flex-shrink-0",
                                    size: "2xl"
                                }, "second-rating-".concat(i));
                            })
                        }),
                        props.pageAnchorId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "#".concat(props.pageAnchorId),
                            className: "absolute top-0 w-[100%] h-[100%]",
                            onClick: function(e) {
                                e.preventDefault();
                                if (props.pageAnchorId) {
                                    (0,utils_scroll_to__WEBPACK_IMPORTED_MODULE_7__/* .scrollTo */ .X)(props.pageAnchorId, -100);
                                }
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StarRatingSRLabel, {
                                rating: rating
                            })
                        })
                    ]
                })
            })
        ]
    }) : null;
};
var StarRatingSRLabel = function(props) {
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_3__/* .useTranslate */ .qM)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: "sr-only",
        children: [
            t("ratingAverage"),
            ": ",
            props.rating.toFixed(1),
            " / 5"
        ]
    });
};


/***/ }),

/***/ 39454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ ScrollToTopButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var twind__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34209);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77480);





var ScrollToTopButton = function() {
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_3__/* .useTranslate */ .qM)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), visible = ref[0], setVisible = ref[1];
    var toggleVisibility = function() {
        return window.pageYOffset > 300 ? setVisible(true) : setVisible(false);
    };
    var scrollToTop = function() {
        return window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        window.addEventListener("scroll", toggleVisibility);
        return function() {
            return window.removeEventListener("scroll", toggleVisibility);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,twind__WEBPACK_IMPORTED_MODULE_4__.tw)("flex justify-center items-center fixed z-10 bottom-3 right-4 h-12 w-12", visible && "focus-within:rounded-1/2 focus-within:border-2 focus-within:border-solid focus-within:border-puma-black-400"),
        children: visible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zxk, {
            onClick: scrollToTop,
            label: t("backToTop"),
            className: (0,twind__WEBPACK_IMPORTED_MODULE_4__.tw)("flex justify-center items-center bg-white rounded-1/2 h-10 w-10 border-1 border-puma-black-500", "md:hover:bg-puma-black-600 animate-fade-in transition-colors duration-200", "focus:rounded-1/2 focus:outline-none focus:shadow-[0px_0px_0px_2px_#8C9198] focus:border-0"),
            icon: "chevron-up",
            variant: "secondary",
            mode: "icon"
        })
    });
};


/***/ }),

/***/ 5567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hH": function() { return /* binding */ createCategoryPageBreadcrumbLinks; },
  "A2": function() { return /* binding */ createProductBreadcrumbLinks; },
  "VD": function() { return /* binding */ fetchBreadcrumbRedirectPromises; }
});

// UNUSED EXPORTS: getLinksToCheck

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(19989);
// EXTERNAL MODULE: ../node_modules/@urql/core/dist/urql-core.mjs
var urql_core = __webpack_require__(70463);
;// CONCATENATED MODULE: ./gql/queries/urlRedirect.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query UrlRedirect($path: String!) {\n    urlRedirectV2(path: $path) {\n      availableFrom\n      availableTo\n      redirectType\n      url\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var URL_REDIRECT_QUERY = (0,urql_core/* gql */.Ps)(_templateObject());

// EXTERNAL MODULE: ./utils/constructCategoryPath.ts
var constructCategoryPath = __webpack_require__(97729);
;// CONCATENATED MODULE: ./utils/breadcrumbRedirects.ts



/**
 * Creates an array of breadcrumb links from a category
 * @param currentCategory - The category data
 * @returns Array of breadcrumb links
 */ var createCategoryPageBreadcrumbLinks = function(currentCategory) {
    var categoryPath = (0,constructCategoryPath/* constructCategoryPath */.h)(currentCategory);
    return [
        {
            label: "home",
            url: ""
        }
    ].concat((0,_to_consumable_array/* default */.Z)(categoryPath));
};
/**
 * Creates breadcrumb links specifically for product detail pages
 * @param params - Object containing necessary data for product breadcrumbs
 * @returns Array of raw breadcrumb links ready for display
 */ var createProductBreadcrumbLinks = function(param) {
    var categoryById = param.categoryById, productName = param.productName, productLink = param.productLink, _isCustomizing = param.isCustomizing, isCustomizing = _isCustomizing === void 0 ? false : _isCustomizing, _customizeUrl = param.customizeUrl, customizeUrl = _customizeUrl === void 0 ? "" : _customizeUrl, _customizeLabel = param.customizeLabel, customizeLabel = _customizeLabel === void 0 ? "customize" : _customizeLabel, _isPersonalizing = param.isPersonalizing, isPersonalizing = _isPersonalizing === void 0 ? false : _isPersonalizing, _personalizeLabel = param.personalizeLabel, personalizeLabel = _personalizeLabel === void 0 ? "personaliseBreadcrumb" : _personalizeLabel;
    var categoryLinks = createCategoryPageBreadcrumbLinks(categoryById);
    var links = (0,_to_consumable_array/* default */.Z)(categoryLinks);
    if (productName && productLink) {
        links.push({
            label: productName,
            url: productLink,
            isAbsoluteUrl: true
        });
    }
    if (isCustomizing && customizeUrl) {
        links.push({
            label: customizeLabel,
            url: customizeUrl
        });
    }
    if (isPersonalizing) {
        links.push({
            label: personalizeLabel,
            url: ""
        });
    }
    return links;
};
/**
 * Gets the links that need to be checked for redirects
 * @param links - The full breadcrumb links array
 * @returns Array of links to check for redirects
 */ var getLinksToCheck = function(links) {
    // Skip first and last elements as per useBreadcrumbUrlRedirects implementation
    return links.slice(1, -1);
};
/**
 * Fetches URL redirect queries for breadcrumb links
 * @param client - The URQL client
 * @param links - The links to check for redirects
 * @returns Promise with the results of the redirect queries
 */ var fetchBreadcrumbRedirectPromises = function(client, links) {
    var linksToCheck = getLinksToCheck(links);
    // Create URL redirect queries for each breadcrumb link
    return linksToCheck.map(function(param) {
        var url = param.url;
        return client.query(URL_REDIRECT_QUERY, {
            path: url.startsWith("/") ? url.slice(1) : url
        });
    });
};


/***/ }),

/***/ 54321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ extractNumbersFromString; }
/* harmony export */ });
var extractNumbersFromString = function(str) {
    var numbers = str.match(/\d+/g);
    return numbers ? Number(numbers.join("")) : 0;
};


/***/ }),

/***/ 27523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "MG": function() { return /* binding */ addCurrencySymbol; },
  "Xp": function() { return /* binding */ formatDefaultPriceRange; },
  "FU": function() { return /* binding */ getDefaultPriceRange; },
  "JF": function() { return /* binding */ get_GA4_SliderPosition; },
  "wr": function() { return /* binding */ handleClearFilter; },
  "at": function() { return /* binding */ handlePriceInputFocus; },
  "x$": function() { return /* binding */ paramsOrPriceRange_Max; },
  "rW": function() { return /* binding */ paramsOrPriceRange_Min; },
  "AH": function() { return /* binding */ removePriceFilterIfMinMaxExists; },
  "fU": function() { return /* binding */ setPriceInputError; },
  "l6": function() { return /* binding */ validatePriceFilterLabel; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(17599);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ./ui/components/ProductListFilterDropdown.tsx + 4 modules
var ProductListFilterDropdown = __webpack_require__(18815);
// EXTERNAL MODULE: ./utils/extractNumbersFromString.ts
var extractNumbersFromString = __webpack_require__(54321);
// EXTERNAL MODULE: ./utils/products.ts
var products = __webpack_require__(1032);
;// CONCATENATED MODULE: ./utils/removeLetters.ts
var removeLetters = function(str) {
    return str.replace(/[a-zA-Z]/g, "").trim();
};

;// CONCATENATED MODULE: ./utils/priceFilter.ts








var formatDefaultPriceRange = function(defaultPriceRange) {
    return defaultPriceRange === null || defaultPriceRange === void 0 ? void 0 : defaultPriceRange.replace("(", "").replace(")", "").split("..").map(function(price) {
        return Number(price);
    });
};
var getDefaultPriceRange = function(data) {
    var ref, ref1;
    var defaultPriceRange = ((ref1 = data === null || data === void 0 ? void 0 : data.values[(data === null || data === void 0 ? void 0 : (ref = data.values) === null || ref === void 0 ? void 0 : ref.length) - 1]) === null || ref1 === void 0 ? void 0 : ref1.value) || "";
    var ref2 = (0,_sliced_to_array/* default */.Z)(formatDefaultPriceRange(defaultPriceRange), 2), min = ref2[0], max = ref2[1];
    return {
        min: String(Math.floor(min)),
        max: String(Math.ceil(max))
    };
};
var addCurrencySymbol = function(price, currencySymbol) {
    // we need to remove the letters from the currency symbol to avoid a price format like CAD$ and to extract only the symbol $
    var formattedCurrencySymbol = removeLetters(currencySymbol);
    return "".concat(formattedCurrencySymbol, " ").concat(price);
};
var setPriceInputError = function(param) {
    var defaultPriceRange = param.defaultPriceRange, delay = param.delay, inputName = param.inputName, priceRange = param.priceRange, ref = param.ref, setPriceRange = param.setPriceRange;
    if (ref === null || ref === void 0 ? void 0 : ref.current) {
        clearTimeout(ref === null || ref === void 0 ? void 0 : ref.current);
    }
    var setDefaultPriceRange = function() {
        setPriceRange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, priceRange), (0,_define_property/* default */.Z)({}, inputName, defaultPriceRange[inputName])));
    };
    ref.current = setTimeout(function() {
        setDefaultPriceRange();
    }, delay);
};
var handleClearFilter = function(props, clearFilters) {
    (0,ProductListFilterDropdown/* focusOnFirst */.RW)(props);
    clearFilters([
        "minPrice",
        "maxPrice"
    ]);
};
var handlePriceInputFocus = function(inputRef, symbol) {
    // we need to add some delay to execute this logic after the component renders when focousing the input
    setTimeout(function() {
        if (inputRef.current) {
            // Set the value to only the currency symbol
            inputRef.current.value = removeLetters(symbol);
            // Place the cursor at the end of the currency symbol
            inputRef.current.setSelectionRange(1, 1);
        }
    }, 0);
};
//this function will remove the Price filter when there is a minMaxPriceRange filter present and the feature flag is enabled, otherwise it will remove the minMaxPriceRange if exist.
var removePriceFilterIfMinMaxExists = function(items, isPriceFilterSliderEnabled) {
    var minMaxPriceRangeEnabled = items.some(function(item) {
        return item.id === products/* wellKnownFilterIds.minMaxPriceRange */.g0.minMaxPriceRange;
    }) && isPriceFilterSliderEnabled;
    if (minMaxPriceRangeEnabled) {
        return items.filter(function(item) {
            return item.id !== products/* wellKnownFilterIds.price */.g0.price;
        });
    } else return items.filter(function(item) {
        return item.id !== products/* wellKnownFilterIds.minMaxPriceRange */.g0.minMaxPriceRange;
    });
};
function validatePriceFilterLabel(str1, str2) {
    if (!str1 || !str2 || typeof str1 !== "string" || typeof str2 !== "string") return false;
    return (0,extractNumbersFromString/* extractNumbersFromString */.a)(str1) === (0,extractNumbersFromString/* extractNumbersFromString */.a)(str2);
}
var paramsOrPriceRange_Min = function(param) {
    var queryParamsPriceRange = param.queryParamsPriceRange, priceRange = param.priceRange;
    return (queryParamsPriceRange === null || queryParamsPriceRange === void 0 ? void 0 : queryParamsPriceRange[0]) || Number(priceRange.min || 0);
};
var paramsOrPriceRange_Max = function(param) {
    var queryParamsPriceRange = param.queryParamsPriceRange, priceRange = param.priceRange;
    return (queryParamsPriceRange === null || queryParamsPriceRange === void 0 ? void 0 : queryParamsPriceRange[1]) || Number(priceRange.max || 0);
};
var get_GA4_SliderPosition = function(minPrice, maxPrice, defaultPriceRange) {
    // this handle categories with unique prices.
    if (minPrice === maxPrice) return {
        slider_low: "5",
        slider_high: "5",
        slider_range: "0"
    };
    // The result from the difference is then divided by 10 to get the value of each interval from 1 to 10
    var defaultValueSegment = (Number(defaultPriceRange.max) - Number(defaultPriceRange.min)) / 10;
    // records the low position as number in a range between 0-10
    var slider_low = Math.round((Number(minPrice) - Number(defaultPriceRange.min)) / defaultValueSegment);
    // records the low position as number in a range between 0-10
    var slider_high = Math.round((Number(maxPrice) - Number(defaultPriceRange.min)) / defaultValueSegment);
    //
    return {
        slider_low: String(slider_low),
        slider_high: String(slider_high),
        slider_range: String(slider_high - slider_low)
    };
};


/***/ }),

/***/ 41403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ scrollTo; }
/* harmony export */ });
var scrollTo = function(id) {
    var yOffset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var element = document.getElementById(id);
    if (element) {
        var y = element.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({
            top: y,
            behavior: "smooth"
        });
    }
};


/***/ }),

/***/ 75142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ splitThreadExecution; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3204);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59312);



function splitThreadExecution() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, uiCallback = ref.uiCallback, mainCallback = ref.mainCallback;
    return /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
        var _len, args, _key, ref, ref1;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = _arguments[_key];
            }
            // Persist React synthetic events if present.
            if ((ref = args[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.persist) === null || ref1 === void 0 ? void 0 : ref1.call(ref)) {
                args[0].persist();
            }
            requestAnimationFrame(function() {
                uiCallback === null || uiCallback === void 0 ? void 0 : uiCallback.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(args));
                setTimeout(function() {
                    mainCallback === null || mainCallback === void 0 ? void 0 : mainCallback.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(args));
                }, 0);
            });
            return [
                2
            ];
        });
    });
}


/***/ })

}]);